import { useCallback, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import usePokemonSearch from "../../hooks/usePokemonSearch";
import Search from "./Search";

function SearchContainer() {
  const [showModal, setShowModal] = useState(false);

  const handleSearchError = useCallback(() => {
    toast.error("Name or id not found, try again!");
  }, []);

  const {
    searchValue,
    pokemon,
    searching,
    loading,
    handleOnChangeSearch,
    searchPokemon: runSearchPokemon,
  } = usePokemonSearch({
    onSearchError: handleSearchError,
  });

  const handleShowModal = () => setShowModal(true);
  const handleSearchPokemon = () => {
    setShowModal(false);
    runSearchPokemon();
  };

  return (
    <>
      <Search
        handleOnChangeSearch={handleOnChangeSearch}
        pokemon={pokemon}
        showModal={showModal}
        handleShowModal={handleShowModal}
        searching={searching}
        searchValue={searchValue}
        searchPokemon={handleSearchPokemon}
        setShowModal={setShowModal}
        loading={loading}
      />
      <Toaster position="top-center" reverseOrder={true} />
    </>
  );
}

export default SearchContainer;
